import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: 'confirm-deletion-modal',
  templateUrl: './confirm-deletion.component.html',
  styleUrls: ['./confirm-deletion.component.css']
})
export class ConfirmDeletionComponent implements OnInit {

  @Output() deleteEvent = new EventEmitter();
  @Output() closeEvent = new EventEmitter();
  @Input() tagOrFolderToDelete: string;
  @Input() isTag: boolean;

  ngOnInit(): void {
  }

  delete() {
    this.deleteEvent.emit();
  }

  cancel($event) {
    if ($event.currentTarget === $event.target) {
      this.closeEvent.emit();
    }
  }
}
